import { render } from "./OscarPoolResultsPage.vue?vue&type=template&id=016247c2&scoped=true"
import script from "./OscarPoolResultsPage.vue?vue&type=script&lang=js"
export * from "./OscarPoolResultsPage.vue?vue&type=script&lang=js"

import "./OscarPoolResultsPage.vue?vue&type=style&index=0&id=016247c2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-016247c2"]])

export default __exports__